/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Col_NameInputs */

const vi_sinp_col_name = /** @type {(inputs: Sinp_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên hàng`)
};

/**

* @param {Sinp_Col_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_col_name = /** @type {((inputs?: Sinp_Col_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Col_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_col_name(inputs)
});